import React, { FC } from "react";

import {
  useApisMembersAnalysisKaizenIdeasCountCalendarsIndex,
  usePrevNextSelectMonth,
} from "~/hooks";

import { ActivityOriginalCalendar } from "~/components/molecules";

type PropsType = {
  className?: string;
};

export const KaizenIdeasCountCalendar: FC<PropsType> = ({
  className = "",
}: PropsType) => {
  const {
    targetDate,
    targetDateString,
    handlePrevMonthClick,
    handleNextMonthClick,
  } = usePrevNextSelectMonth();
  const { data, isLoading } =
    useApisMembersAnalysisKaizenIdeasCountCalendarsIndex({
      params: {
        targetDate: targetDateString,
      },
    });
  return (
    <ActivityOriginalCalendar
      isLoading={isLoading}
      dailyActivity={data?.kaizenIdeasCalendar}
      targetDate={targetDate}
      onPrevMonthClick={handlePrevMonthClick}
      onNextMonthClick={handleNextMonthClick}
      isForRate={false}
      className={className}
    />
  );
};
